
import {mapState} from 'vuex';

export const FaqFormatMixin = 
{ 
    computed: {
        ...mapState({
            FAQ_TYPE_CUSTOMER: state => state.codeDictionary.items.FAQ_TYPE_CUSTOMER,
            QNA_STATUS: state => state.codeDictionary.items.QNA_STATUS,
        }),
    },
    methods: {
        faqType(type) {
            let faqType = Object.values(this.FAQ_TYPE_CUSTOMER).find(e => e.id == type);
            return (faqType) ? faqType.title : '';
        },

        qnaStatus(status){
            let qnaStatus = Object.values(this.QNA_STATUS).find(e => e.id == status);
            return (qnaStatus) ? qnaStatus.title : '';
        }

    },
};